export default "__VITE_ASSET__Bimhq5f___"